<script setup lang="ts">
</script>
<template>
  <FormsEnterpriseContact goal="the Enterprise plan for Axon Server" :to-slack-message="(contactType: string, email: string, phone: string, comments: string, goal) => `
:rotating_light::rotating_light: Attention Sales team! :rotating_light::rotating_light: \n
I'm interested in ${goal}. Please contact me via ${contactType} at ${contactType === 'email' ? email : 'my phone number'}. \n
Additional comments: ${comments.length === 0 ? 'None' : comments} \n
User E-mail: ${email}
Desired Contact E-mail: ${email}
Desired Contact Phone Number: ${phone}
        `"></FormsEnterpriseContact>
</template>
